import styled from '@xstyled/styled-components';
import React from 'react';
import { createPortal } from 'react-dom';
import { t } from 'ttag';
import LockIcon from '~/assets/icons/white_lock.svg';
import { select } from '~/lib/select';
import { TrainingState, useTrainingStore } from '~/training/state';

const Icon = styled(LockIcon)({
  width: '23px',
  height: '25px',
  marginRight: 'xs',
  float: 'left'
});

const Block = styled.div`
  position: fixed;
  bottom: 10px;
  left: 70px;
  z-index: hud;
  min-width: 260px;
  padding-top: 15px;
  padding-bottom: 7px;
  padding-left: 24px;
  border-radius: 10px;
  background: #000000;
  color: #ffffff;
  opacity: 0.9;
  > p {
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    font-feature-settings: 'pnum' on, 'lnum' on;
    margin-left: 40px;
    padding-right: 20px;
  }
  > a {
    display: block;
    font-size: 12px;
    margin-left: 40px;
  }
`;

const selector = (s: TrainingState) => select(s,


  'player', 'showDemoBanner');

export const DemoMode = () => {
  const { player, showDemoBanner } = useTrainingStore(selector);

  if (!showDemoBanner || (player != 'demo' && player != 'demo_limited' && player != 'demo_full')) {
    return null;
  }

  return createPortal(
    <Block>
      <Icon />
      <p>{player === 'demo_limited' ? t`This is a limited demo` : t`This is a demo course`}</p>
      <a href="https://www.easyllama.com/pricing">
        {player === 'demo_limited' ? t`Buy now to access all chapters` : t`Buy full access now`}
      </a>
    </Block>,
    document.getElementById('root')!
  );
};
